import React, {PropsWithChildren} from "react";
import {Box} from "@unibuddy/patron";

export const ConversationPopupWrapper = ({children}: PropsWithChildren) => {
    return (
        <Box padding="small-medium" bgColor="white" borderBottomWidth={1} borderColor="grey100">
            {children}
        </Box>
    );
};
